import { ActionPermission } from '@core/models/action-permission.model';
import { RiskPermission } from '@core/models/risk-permission.model';
import { StaticPermission } from '@core/models/static-permission.model';
import { createAction, props } from '@ngrx/store';
import { ServicePermission } from '@core/models/service-permission.model';
import { InterplanPermission } from '@core/models/interplan-permission.model';

export const setStaticPermissions = createAction(
    '[Permissions] - Set Static Permissions',
    props<{ staticPermissions: StaticPermission }>(),
);

export const resetStaticPermissions = createAction(
    '[Permissions] - Reset Static Permissions',
);

export const setRiskPermissions = createAction(
    '[Permissions] - Set Risk Permissions',
    props<{ riskPermissions: RiskPermission }>(),
);

export const resetRiskPermissions = createAction(
    '[Permissions] - Reset Risk Permissions',
);

export const setActionPermissions = createAction(
    '[Permissions] - Set Action Permissions',
    props<{ actionPermissions: ActionPermission }>(),
);

export const resetActionPermissions = createAction(
    '[Permissions] - Reset Action Permissions',
);

export const setServicePermissions = createAction(
    '[Permissions] - Set Service Permissions',
    props<{ servicePermissions: ServicePermission }>(),
);

export const resetServicePermissions = createAction(
    '[Permissions] - Reset Service Permissions',
);

export const setInterplanPermissions = createAction(
    '[Permissions] - Set Interplan Permissions',
    props<{ interplanPermissions: InterplanPermission }>(),
);

export const resetInterplanPermissions = createAction(
    '[Permissions] - Reset Interplan Permissions',
);
